<div class="institution-transfer-root flex flex-col items-stretch gap-4 sm:flex-row sm:gap-6">
  <div class="flex-1 min-w-0">
    <span [id]="'available-institutions-label-' + idPrefix()"
      class="text-[10px] font-black text-slate-800 uppercase tracking-widest mb-3 flex items-end gap-2 sm:min-h-[40px]">
      Available Institutions
    </span>
    <div #availableList class="h-64 border rounded-2xl p-2 space-y-1 overflow-y-auto bg-slate-50/20 transition-colors"
      aria-label="Available Institutions"
      [attr.aria-labelledby]="'available-institutions-label-' + idPrefix()" role="listbox" tabindex="0"
      (click)="focusListContainer($event)"
      (keydown)="availableKeydown.emit($event)" (focusout)="onAvailableListFocusOut($event)"
      [class]="isEditable() ? 'border-slate-500' : 'border-slate-300'">
      @for (inst of availableInstitutions(); track inst) {
      <div #availableItem
       [attr.data-name]="inst" (click)="isEditable() && availableSelectedToggle.emit(inst)"
        class="px-4 py-2.5 text-xs font-bold rounded-lg transition-all" [class]="isEditable()
      ? (selectedAvailable().includes(inst)
      ? 'bg-blue-100  border border-blue-100 cursor-pointer'
      : 'text-slate-600 hover:bg-blue-50 hover:shadow-sm cursor-pointer')
      : 'text-slate-600 cursor-default'">
        {{ inst }}
      </div>
      }
    </div>
  </div>

  <div class="flex flex-row justify-center gap-3 sm:flex-col sm:mt-[52px] sm:h-64 sm:justify-center">
    <button (click)="moveToAssignedClick.emit()" [disabled]="!isEditable()"
      class="w-12 h-10 flex items-center justify-center bg-transparent border rounded-xl text-slate-500 hover:text-slate-700 hover:border-slate-400 hover:bg-slate-50 transition-all disabled:opacity-30 disabled:pointer-events-none"
      [class]="isEditable() ? 'border-slate-500' : 'border-slate-300'">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path d="M9 5l7 7-7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
        <button (click)="moveAllToAssignedClick.emit()" [disabled]="!isEditable()"
      class="w-12 h-10 flex items-center justify-center bg-transparent border rounded-xl text-slate-500 hover:text-slate-700 hover:border-slate-400 hover:bg-slate-50 transition-all disabled:opacity-30 disabled:pointer-events-none"
      [class]="isEditable() ? 'border-slate-500' : 'border-slate-300'" title="Move All">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path d="M13 5l7 7-7 7M5 5l7 7-7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
        <button (click)="moveToAvailableClick.emit()" [disabled]="!isEditable()"
      class="w-12 h-10 flex items-center justify-center bg-transparent border rounded-xl text-slate-500 hover:text-slate-700 hover:border-slate-400 hover:bg-slate-50 transition-all disabled:opacity-30 disabled:pointer-events-none"
      [class]="isEditable() ? 'border-slate-500' : 'border-slate-300'">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path d="M15 5l-7 7 7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <button (click)="moveAllToAvailableClick.emit()" [disabled]="!isEditable()"
      class="w-12 h-10 flex items-center justify-center bg-transparent border rounded-xl text-slate-500 hover:text-slate-700 hover:border-slate-400 hover:bg-slate-50 transition-all disabled:opacity-30 disabled:pointer-events-none"
      [class]="isEditable() ? 'border-slate-500' : 'border-slate-300'" title="Move All">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path d="M11 19l-7-7 7-7m8 14l-7-7 7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <div class="flex-1 min-w-0">
    <span [id]="'assigned-institutions-label-' + idPrefix()"
      class="text-[10px] font-black text-slate-800 uppercase tracking-widest mb-3 flex items-end gap-2 flex-wrap sm:min-h-[40px]">
      Assigned Institutions
    </span>
    <div #assignedList class="h-64 border rounded-2xl p-2 space-y-1 overflow-y-auto bg-slate-50/20 transition-colors"
      aria-label="Assigned Institutions" (click)="focusListContainer($event)"
      [attr.aria-labelledby]="'assigned-institutions-label-' + idPrefix()" role="listbox" tabindex="0"
      (keydown)="assignedKeydown.emit($event)" (focusout)="onAssignedListFocusOut($event)"
      [class]="isEditable() ? 'border-slate-500' : 'border-slate-300'">
      @for (inst of assignedInstitutions(); track inst.id) {
      <div (click)="isEditable() && assignedSelectedToggle.emit(inst.name)"
        class="px-4 py-2.5 text-xs font-bold rounded-lg transition-all"
        [class]="isEditable()
      ? (selectedAssigned().includes(inst.name)
          ? 'bg-blue-100  border border-blue-100 cursor-pointer'
      : 'text-slate-600 hover:bg-blue-50 hover:shadow-sm cursor-pointer')
  : 'text-slate-600 cursor-default'">
        {{ inst.name }}
      </div>
      }
    </div>
  </div>
</div>
